import React, { useRef } from "react";
import logo from "../../assets/logo.svg";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./nav.css";
import menu from "../../assets/Menu.svg";
const buttonVariants = {
  tap: {
    scale: 0.9,
    rotate: [0, -5, 5, -5, 5, 0],
    transition: {
      duration: 0.5,
    },
  },
};

function NavBar() {
  const navRef = useRef();
  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };
  return (
    <header className="navbar__container">
      <div className="logo">
        <img src={logo} alt="" />
      </div>

      <div className="navbar__links">
        <nav className="navlinks" ref={navRef}>
          <motion.a variants={buttonVariants} whileTap="tap" href="#home">
            <span className="hashtag">#</span>Home
          </motion.a>
          <motion.a variants={buttonVariants} whileTap="tap" href="#about">
            <span className="hashtag">#</span>AboutMe
          </motion.a>
          <motion.a variants={buttonVariants} whileTap="tap" href="#skills">
            <span className="hashtag">#</span>Skills
          </motion.a>
          <motion.a variants={buttonVariants} whileTap="tap" href="#project">
            <span className="hashtag">#</span>Projects
          </motion.a>
          <motion.a variants={buttonVariants} whileTap="tap" href="#contact">
            <span className="hashtag">#</span>Contacts
          </motion.a>

          <FontAwesomeIcon
            icon={faTimes}
            size="xl"
            color="#f2a20f"
            className="nav-btn nav-close-btn"
            onClick={showNavbar}
          />
        </nav>
      </div>

      <div className="cart"></div>

      <img src={menu} alt="" className="nav-btn" onClick={showNavbar} />

      {/* cart section */}
    </header>
  );
}

export default NavBar;
